// import Swiper from 'swiper'; 最小限の機能しか入っていない
import Swiper from 'swiper/bundle'; // 全ての機能が入っている

document.addEventListener("DOMContentLoaded", function () {

    const swiperElement = document.querySelector(".swiper-eyecatch-front");
    if (swiperElement) {
        const swiper = new Swiper(swiperElement, {
            loop: true,
            speed: 2000,
            spaceBetween: 30,
            effect: "fade",
            autoplay: {
                delay: 1500,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });
    }

    // body要素のクラスにhomeが存在しない場合にのみ処理を実行する

    var adminBarHeight = document.querySelector("#wpadminbar") ? document.querySelector("#wpadminbar").offsetHeight : 0;
    document.querySelector("#wrapper-navbar .fixed-top").style.top = adminBarHeight + 'px';
    if (!document.body.classList.contains('home')) {
        // ヘッダーの高さを取得する
        var headerHeight = document.querySelector("#wrapper-navbar .fixed-top").offsetHeight + 30;
        // body要素にpadding-topを追加する
        document.body.style.paddingTop = headerHeight+ "px";
    }
});

document.addEventListener("DOMContentLoaded", function () {
    new Swiper('.swiper-container', {
        loop: true,
        spaceBetween: 40,
        slidesPerView: 2,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            992: { 
                slidesPerView: 2,
                spaceBetween: 20,
            }, // スマホは2枚表示
            0: { 
                slidesPerView: 1 
            }  // 狭い画面は1枚表示
        }
    });
});

$(document).ready(function() {
    // すべての画像が読み込まれたらフェードイン
    $('.top-visual__img img, .top-visual__img2 img, .top-visual__img3 img').each(function() {
        $(this).on('load', function() {
            $(this).hide().fadeIn(1000); // 画像を非表示にしてから1秒かけてフェードイン
        });

        // 画像がキャッシュから読み込まれた場合にも対応
        if (this.complete) {
            $(this).trigger('load');
        }
    });
});